<template>
  <Tooltip.Hint :text="label">
    <RouterLink
      v-if="to && !disabled"
      :aria-label="label"
      :to="to"
      :class="cls"
    >
      <component :is="iconMappingMicro[icon]" class="size-4" />
    </RouterLink>
    <button
      v-else
      type="button"
      :aria-label="label"
      :disabled="disabled"
      :class="cls"
    >
      <component :is="iconMappingMicro[icon]" class="size-4" />
    </button>
  </Tooltip.Hint>
</template>

<script setup lang="ts">
import { normalizeClass } from "vue";
import { RouterLink } from "vue-router";

import Tooltip from "@/design_system/Tooltip";
import {
  type MappedIconMicro,
  iconMappingMicro,
} from "@/icons/icon-mapping-micro";
import type { RouteLocation } from "@/router/types";

defineProps<{
  label: string;
  icon: MappedIconMicro;
  to?: RouteLocation;
  disabled?: boolean;
}>();

const cls = normalizeClass([
  `rounded-full p-[0.4375rem] text-gray-700 outline-2 outline-action transition hover:bg-gray-200 focus-visible:outline active:bg-gray-200 disabled:cursor-not-allowed disabled:opacity-50 aria-expanded:bg-gray-200 dark:text-muted-foreground dark:hover:bg-card dark:active:bg-card dark:aria-expanded:bg-card`,
]);
</script>
